import React, { Component } from 'react'
import ImageOnlyUpload from '../../pages/ImageOnlyUpload';
import TextEditor from '../TextEditor';
import Slider  from 'react-slick';
import UploadForm from '../../component/fpg/create/UploadForm';
import { Player } from 'video-react';
import PlusIcon from '../../icons/plusicon';
import { PlayToggle } from 'video-react';
import DeletefileIcon from '../../icons/DeletefileIcon';
import CopyIcon from '../../icons/copyicon';
import { ControlBar } from 'video-react';
import Loader from '../loader';
//moment import
import _ from 'lodash'
import moment from "moment-timezone";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import FpgMinusIcon from '../../icons/fpgminusicon';
//import AWS from "aws-sdk";
import AWS from "aws-sdk";
import $ from 'jquery'
//Service import
import service from '../../services'
import PopUpCustomAll from '../fpg/create/popUpCustomAll';
import ErrorPopUp from '../errorPopUp';
import VideoOnlyUpload from '../../pages/VideoOnlyUpload';
import VideoImageFile from "./../../component/VideoImageFile";
import SimpleReactValidator from 'simple-react-validator';
import commonImage from '../../commonImage';

let sub;

const EXT_IMAGES = /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i;
const EXT_VIDEO = /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;

export default class VillageHomePage extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            imagePreloader:false,
            videoPreLoader:false,
            villegeHomePageId:'',
            isImage: false,
            pageDescription:EditorState.createEmpty(),
            media: [
                {
                  _id: Math.random(),
                  media: "",
                  mediaUrl: ""
                },
                {
                  _id: Math.random(),
                  media: "",
                  mediaUrl: ""
                },
                {
                  _id: Math.random(),
                  media: "",
                  mediaUrl: ""
                }
              ],
              featuredEventSearch:[],
              featuredEvent:[],
              promotionalEventArray:[],
              searchField:'',
              promotionalEventId:''
        }
        this.validator = new SimpleReactValidator();
        this.apiserve = new service();
    }

    componentDidMount = () => {
      this.getHowToFestPlatformEvent()
      // Promotional Event

      $(document).ready(function () {
          $('#popup').hide()
      });
   
      $('#open').on('click', function () {
          $('#popup').show(100)
      });
   
      $(document).mouseup(function (e) {
          var popup = $("#popup");
          if (!$('#open').is(e.target) && !popup.is(e.target) && popup.has(e.target).length == 0) {
              popup.hide(100);
          }
      });

      // Featured Events

      $(document).ready(function () {
        $('#popup1').hide()
    });
 
      $('#open1').on('click', function () {
          $('#popup1').show(100)
      });
 
      $(document).mouseup(function (e) {
          var popup1 = $("#popup1");
          if (!$('#open').is(e.target) && !popup1.is(e.target) && popup1.has(e.target).length == 0) {
              popup1.hide(100);
          }
      });
    }

    componentWillUnmount = () => {
      sub.unsubscribe();
    }

    // Dummy API
    getHowToFestPlatformEvent = () => {
      this.festivalHomePageGetList()
        sub = this.apiserve.getevent().subscribe(response => {
          switch (response.event) {
            case "FestivalVillage|FestivalVillageHomePage|getList":
              if (!response.error) {
                if(response.data._id){
                  var media =
                  response.data &&
                  response.data.media &&
                  response.data.media.map(image => {
                    var imageData = {
                      _id: Math.random(),
                      media: image.media,
                      mediaUrl: image.mediaUrl
                    };
                    return imageData;
                  });
                if (media) {
                  this.setState({
                    loaderFlag: false,
                    media: media !== undefined ? media : this.state.media
                  });
                } else this.setState({ loaderFlag: false });
                  const blocksFromHtml = htmlToDraft(response.data.pageDescription ? response.data.pageDescription : '');
                  const { contentBlocks, entityMap } = blocksFromHtml;
                  const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                  const editorState = EditorState.createWithContent(contentState);   
                  this.setState({
                    villegeHomePageId:response.data._id,
                    pageTitle:response.data.pageTitle,
                    editorState:editorState,
                    promotionalEvent:response.data.promotionalEvent && response.data.promotionalEvent.eventTitle,
                    promotionalEventDetails:response.data.promotionalEvent && response.data.promotionalEvent,
                    promotionalEventId:response.data.promotionalEvent && response.data.promotionalEvent._id,
                    featuredEvent:response.data.featuredEvent,
                    updateDate: response.data.updatedAt,
                    updatedBy:response.data.updatedBy
                  })
                }
              else{
                this.setState({
                  pageTitle:this.state.pageTitle,
                  pageDescription:EditorState.createEmpty(),
                  promotionalEvent:this.state.promotionalEvent,
                  promotionalEventId:this.state.promotionalEvent,
                  featuredEvent:this.state.featuredEvent,
                })
              }
               
          }
          break;
          case "FestivalVillage|FestivalVillageHomePage|searchEvent":
            if (!response.error) {
              if(this.state.searchField && this.state.searchField.length){
                const featuredEventSearchData = this.state.featuredEventSearch && this.state.featuredEventSearch.map(item => item._id);
                const featuredEventData =this.state.featuredEvent && this.state.featuredEvent.map(item => item._id);
                const featuredList = response.data.docs.filter(
                  item => !(featuredEventSearchData&&featuredEventSearchData.includes(item._id) || featuredEventData&&featuredEventData.includes(item._id))
                );

                this.setState({
                  featuredEventSearch:featuredList,
                })
              }else{
                if(this.state.promotionalEvent && this.state.promotionalEvent.length){
                    this.setState({
                      promotionalEventArray:response.data.docs,
                  })
                }
              }  
            }
            break;
            case "FestivalVillage|FestivalVillageHomePage|edit":
              if (!response.error) {
                  this.setState({
                      loaderFlag:false,
                   },()=>{
                    this.festivalHomePageGetList()
                   })
                  this.apiserve.success("Village Home Page update successfully.")
              }
              else
              {
                  this.setState({
                      errorPopup:true,
                      errorMsg: response.data.error ? response.data.error : response.data 
                 })
              }
              break;
              case "FestivalVillage|FestivalVillageHomePage|create":
                if (!response.error) {
                    this.setState({
                        loaderFlag:false,
                     },()=>{
                      this.festivalHomePageGetList()
                     })
                    this.apiserve.success("Village Home Page create successfully.")
                }
                else
                {
                    this.setState({
                        errorPopup:true,
                        errorMsg: response.data.error ? response.data.error : response.data 
                   })
                }
                case "FestivalVillage|Event|Preview|create":
                  if (!response.error) {
                      this.setState({
                          loaderFlag:false,
                       },()=>{
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FESTIVAL_VILLAGE + 'home-preview');
                       })
                  }
                  else
                  {
                      this.setState({
                          errorPopup:true,
                          errorMsg: response.data.error ? response.data.error : response.data 
                     })
                  }
                break;
        }
        });
    };

    festivalHomePageGetList = () => {
        this.apiserve.sendevent("FestivalVillage|FestivalVillageHomePage|getList", {});
        this.setState({ loaderFlag: true })
    }

    onInputChange = (e) => {
      this.setState({
          [e.target.name]: e.target.value
      });
    }

    onEditorState = (editorState) => {
      this.setState({
        editorState
      });
    };

    onChangeFile = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);    reader.onloadend = (event) => {
      this.setState({
        file: file
        // base64: reader.result
      });
      if (
        (file && file.type === "image/png") ||
        (file && file.type === "image/jpg") ||
        (file && file.type === "image/jpeg")
      ) {
        const fileList = Math.round(file && file.size / 1024);
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: "Please upload a file smaller than 2 MB"
          });
          return false;
        }
        if (file && (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg")) {
              // this.setState({ isImage: true });
            setTimeout(() => {
              this.uploadVideoImage(file, id,event.target.result);
            }, 0);
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
          });
        }
      } else {
        if (file.size > 200e6) {
          this.setState({
            errorPopup: true,
            errorMsg: "Please upload a video smaller than 200 MB"
          });
          return false;
        }

        if (file.type === "video/mp4") {
          setTimeout(() => {
            this.uploadVideoImage(file, id,event.target.result);
          }, 0);
          return false;
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
          });
        }
      }
    };
  };

    setDeleteFilePopup = (e, id) => {
      this.setState({
        deleteImagePopup: true,
        deleteId: id
      });
    };

    onDeleteImagePopup = () => {
      this.state.media.forEach(image => {
        if (image._id === this.state.deleteId) {
          image.mediaImage = "";
        }
      });
      this.setState({
        deleteImagePopup: false
      });
    };
    closeAdminUser = () => {
      this.setState({ deleteImagePopup: false });
    };

    uploadVideoImage = (file, id, img) => {
      const imagePreloaderId = `imagePreloader_${id}`;
      const newState = { ...this.state, videoPreLoader: true };
      newState[imagePreloaderId] = true;
      this.setState(newState);
      var fileSet= commonImage(file,false,'',img)
       fileSet.then((value) => {
        this.state.media.forEach(image => {
          const imagePreloaderId = `imagePreloader_${id}`;
          const newState = { ...this.state };
          newState[imagePreloaderId] = false;
          this.setState(newState);
  
          if (image._id === id) {
            image.media = value;
          }
        });
        this.setState({});
      });
    };

    setDeleteImagePopup = (id) => {
      this.setState({
        deleteImagePopup:true,
        deleteId:id
      })
    }

    onDeleteImagePopup = () => {
      this.state.media.forEach(image => {
        if (image._id === this.state.deleteId) {
          image.media = "";
        }
      });
      this.setState({
          deleteImagePopup:false
      })
    }
    closeAdminUser = () => {
    this.setState({  deleteImagePopup:false})
    };

    onPasteLink = (e, id) => {
      const { name, value } = e.target;
      const media = Object.assign([], this.state.media);
      media.map(m => {
        if (m._id === id) {
          m.mediaUrl = value;
        }
        return m;
      });
      this.setState({ media });
    };

    onSearchFilter = e => {
      this.setState(
        {
          [e.target.name]: e.target.value
        },
        () => {
          if (this.state.searchField.length) {
            this.apiserve.sendevent("FestivalVillage|FestivalVillageHomePage|searchEvent", {
              filter: this.state.searchField
            });
          }
        }
      );
    };

    onPromotionalEvent = e => {
      this.setState(
        {
          [e.target.name]: e.target.value
        },
        () => {
          if (this.state.promotionalEvent.length) {
            this.apiserve.sendevent("FestivalVillage|FestivalVillageHomePage|searchEvent", {
              filter: this.state.promotionalEvent
            });
          }else{
            this.setState({
              promotionalEventId:""
            })
          }
        }
      );
    };

    searchAddFeatured = (item) => {
      let data = {
        _id:item._id,
        eventId:item
      }
      this.setState({
        featuredEvent: [...this.state.featuredEvent, data],
        searchField:'',
        featuredEventSearch:[]
      });
    }

    searchAddPromotionalEvent = (item) => {
      this.setState({
        promotionalEvent: item.eventTitle ? item.eventTitle : item.offerTitle,
        promotionalEventId:item._id,
        promotionalEventArray:[],
        promotionalEventDetails:item
      });
    }

    revoveFeatured = i => {
      var featuredEvent = this.state.featuredEvent.filter(_=>_._id !== i)
      this.setState({
        featuredEvent: featuredEvent
      });
    }

    villegeHomeSubmit = (e) => {
      e.preventDefault();
      if (this.validator.allValid()) {
        this.setState({ loaderFlag: true });
        
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const  markup= draftToHtml(name);
  
        let featureList = this.state.featuredEvent.map(element => {
            var data = {
              eventId: element.eventId._id
            }
            return data
        });
  
        this.state.media.forEach(element => {
          delete element._id
        });

        var result = _.filter(_.uniq(this.state.media, function(item, key, a) {
          return item._id;
        }), function(element) {
          return element.media || element.mediaUrl
        });
  
        if(this.state.villegeHomePageId){
          let updateVillegeData = {
            id:this.state.villegeHomePageId,
            pageTitle:this.state.pageTitle,
            pageDescription:markup,
            media:this.state.media,
            frontMedia:result,
            promotionalEvent:this.state.promotionalEventId,
            featuredEvent:featureList
          }
          this.apiserve.sendevent("FestivalVillage|FestivalVillageHomePage|edit", updateVillegeData);
        }else{
          let createVillegeData = {
            pageTitle:this.state.pageTitle,
            pageDescription:markup,
            media:this.state.media,
            frontMedia:result,
            promotionalEvent:this.state.promotionalEventId,
            featuredEvent:featureList
          }
          this.apiserve.sendevent("FestivalVillage|FestivalVillageHomePage|create", createVillegeData);
        }
      }
      else{
        this.validator.showMessages();
        this.forceUpdate();
      }
    }

    previewRecord = (e) => {
      e.preventDefault()
      let previewDetails = {}
      if (this.validator.allValid()) {
        this.setState({ loaderFlag: true });
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const  markup= draftToHtml(name);
  
        let featureList = this.state.featuredEvent.map(element => {
          var data = {
            _id:element.eventId._id,
            keyEventThumbnailImage:element.eventId.keyEventThumbnailImage,
            eventTitle:element.eventId.eventTitle ? element.eventId.eventTitle : element.eventId.offerTitle,
            eventDate:element.eventId.eventDate,
            eventDisplayTemplate: element.eventId.eventDisplayTemplate
          }
          return data
        });
  
        var result = _.filter(_.uniq(this.state.media, function(item, key, a) {
          return item._id;
        }), function(element) {
          return element.media || element.mediaUrl
        });
          previewDetails = {
            pageTitle:this.state.pageTitle,
            pageDescription:markup,
            media:this.state.media,
            frontMedia:result,
            promotionalEvent:this.state.promotionalEventDetails,
            featuredEvent:featureList
          }
          if (this.state.villegeHomePageId) previewDetails.id = this.state.villegeHomePageId
          let previewString = this.apiserve.e(previewDetails)
          this.apiserve.sendevent("FestivalVillage|Event|Preview|create", {previewString});
      } else{
        this.validator.showMessages();
        this.forceUpdate();
      }
  }

      errorMsgPopup = () => {
        this.setState({
            errorPopup:false
        })
      }

      insideFilechange = (e, id) => {
        const { name, value } = e.target;
        this.state.media.forEach(image => {
          if (image._id === id) {
            image.mediaUrl = value;
          }
        });
        this.setState({});
      };

        render() {
        var settings = {
            customPaging: function (i) {
              return <a>{i + 1}</a>;
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
          };
          const self = this;
        return (
            <div className="right_side_wrapper partnerEventAdminView_wrapper fest_contents p_0">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="text_left">
                            <div>
                            Festival Village Home Page Content
                            </div>
                        </p>
                    </li>
                </ul>    
                {this.state.updateDate === undefined ? '' :
                <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                  <p></p>
                  <p className="update_date">
                    Last Update: {moment(this.state.updateDate).tz("US/Mountain").format('h')}:{moment(this.state.updateDate).tz("US/Mountain").format('mm')} {moment(this.state.updateDate).tz("US/Mountain").format('A')}{' '}
                  MT- {moment.tz(this.state.updateDate, "US/Mountain").format('MM/DD/YYYY')}{' '}Last Updated By: {this.state.updatedBy && this.state.updatedBy.fname} {this.state.updatedBy && this.state.updatedBy.lname}
                  </p>
                </div>
                }
                <div className="tab-panels">
                    <div className="tab-panel screenigBlock_wrapper PanelBlock_wrapper">
                        <form className="ml_0 product_coupon_form" onSubmit={e => { e.preventDefault(); }}>
                            <div className="ml_15">
                                <div className="EventTitle_block">
                                    <div className="textarea_block form_group">
                                    <h5 className="left_label">Page Title</h5>
                                    <div className="form_group_textarea">
                                      <input
                                          type="text"
                                          name="pageTitle"
                                          placeholder="Festival Village"
                                          value={self.state.pageTitle}
                                          onChange={this.onInputChange}
                                          autoComplete="off"
                                      />
                                      <span className="error">
                                        {this.validator.message("page title", self.state.pageTitle, "required")}
                                      </span>
                                    </div>
                                    </div>
                                </div>
                                <div className="description_block sd_editer_event">
                                    <div className="textarea_block form_group">
                                        <h5 className="left_label">Page Description </h5>
                                        <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                                          <TextEditor
                                              name="editorState"
                                              editorState={this.state.editorState}
                                              value={this.state.editorState}
                                              onEditorStateChange={(e) => this.onEditorState(e)}
                                          />
                                          <span className="error">
                                            {this.validator.message("Page Description", this.state.editorState, "required")}
                                          </span>
                                        </div>
                                    </div>
                                </div> 
                                <div className="EventTitle_block">
                                    <div className="textarea_block form_group m_0">
                                        <h5 className="left_label mr_25">Media</h5>
                                    </div>
                                    <div className="video_slider uploads_files mb_25"  style={{display:"block"}}>
                                      <Slider {...settings}>
                                      {self.state.media &&
                                        self.state.media.map((item, i) => {
                                        const imagePreloaderState = `imagePreloader_${item._id}`
                                        return self.state.isImage ||
                                          item.media.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null ||
                                          item.mediaUrl.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null ? (
                                            <div className=" file_upload_400 relative">
                                              <div className="uploads_files">
                                                <VideoImageFile
                                                  item={item._id}
                                                    handleImage={e => self.onChangeFile(e, item._id)}
                                                    iconDelete={true}
                                                    size="2"
                                                    id={item._id}
                                                    image={item.mediaUrl}
                                                    showDeleteIcon={item.media}
                                                    value={
                                                      item.media
                                                        ? self.apiserve.imageUrl + item.media
                                                        : item.mediaUrl
                                                    }
                                                    insideOnchange={e => self.insideFilechange(e, item._id)}
                                                    videoPreLoader={self.state[imagePreloaderState]}
                                                    deleteImage={e => self.setDeleteFilePopup(e, item._id)}
                                                    isboth={true}
                                                    textChange={true}
                                                  />
                                            </div>
                                          </div>
                            ) : (
                              <div className="file_upload_400 relative">
                                <div className="uploads_files">
                                  <VideoOnlyUpload
                                    handleVideo={e => self.onChangeFile(e, item._id)}
                                    url={
                                      item.media
                                        ? `${self.apiserve.imageUrl}${item.media}`
                                        : item.mediaUrl
                                    }
                                    video={
                                      item.media
                                        ? `${self.apiserve.imageUrl}${item.media}`
                                        : item.mediaUrl
                                    }
                                    videoUrl={item.mediaUrl}
                                    insideOnchange={e => self.insideFilechange(e, item._id)}
                                    item={item}
                                    iconDelete={true}
                                    showDeleteIcon={item.media}
                                    videoPreLoader={self.state[imagePreloaderState]}
                                    // setErrorMsg={setErrorMsg} setErrorPopup={setErrorPopup}
                                    deleteVideo={e => self.setDeleteFilePopup(e, item._id)}
                                    uploadmessage="Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
                                  />
                                </div>
                              </div>
                            );
                          })}
                      </Slider> 
                                    </div>
                                </div>   
                                <div className="EventTitle_block">
                                    <div className="textarea_block form_group">
                                      <h5 className="left_label">Promotional Event</h5>
                                      <div className="relative"  style={{width:"400px",marginLeft:"28px"}}  >
                                          <div className="form_group_textarea" id="open" >
                                            <input
                                                type="text"
                                                name="promotionalEvent"
                                                placeholder="Type event name to find and select"
                                                value={this.state.promotionalEvent}
                                                onChange={this.onPromotionalEvent}
                                                style={{width:"100%",marginLeft:"0px"}}    
                                                autoComplete="off" 
                                            />
                                             {/* <span className="error ml_0">
                                              {this.validator.message("Type event name", this.state.promotionalEvent, "required")}
                                            </span> */}
                                          </div>
                                          <ul className="suggession_coupon mx_100 cms_bg" id="popup">
                                              {this.state.promotionalEventArray.map((item,i)=>(
                                                  <li onClick={()=>this.searchAddPromotionalEvent(item)}>
                                                      {item.eventTitle ? item.eventTitle : item.offerTitle}
                                                  </li>
                                              ))}
                                            </ul>
                                      </div>
                                    </div>
                                </div>
                               
                                <div className="EventTitle_block">
                                    <div className="textarea_block form_group">
                                      <h5 className="left_label">Featured Events</h5>
                                      <div className="relative ml_25"  style={{width:"400px",marginLeft:"28px"}} >
                                        <div className="form_group_textarea" id="open1">
                                          <input
                                              type="text"
                                              name="searchField"
                                              placeholder="Type event name to find and select multiples by keeping entering"
                                              value={this.state.searchField}
                                              onChange={this.onSearchFilter}
                                              style={{width:"100%",marginLeft:"0px"}}
                                              className="m_0"
                                              autoComplete="off"    
                                          />
                                           {/* <span className="error ml_0">
                                            {this.validator.message("Featured Events", this.state.searchField, "required")}
                                          </span> */}
                                        </div>
                                        {/* Search Code here */}

                                         <ul className="suggession_coupon mx_100 cms_bg" id="popup1">
                                         {this.state.featuredEventSearch.map((item,i)=>(
                                            <li onClick={()=>this.searchAddFeatured(item)}>
                                                {item.eventTitle ? item.eventTitle : item.offerTitle}
                                            </li>
                                         ))}
                                        </ul>

                                        <ul className="featured_remove">
                                          {this.state.featuredEvent.map((item,i)=>(
                                            <li>
                                            <div className="inner_remove d_flex">
                                              <p>{item && item.eventId && item.eventId.eventTitle ? item && item.eventId && item.eventId.eventTitle : item && item.eventId && item.eventId.offerTitle}</p>
                                              <span className="pointer" onClick={e => this.revoveFeatured(item._id)}><FpgMinusIcon width="20px" height="20px" color="#7758B3" /></span>
                                            </div>
                                          </li>
                                          ))}
                                          
                                        </ul>
                                      </div>
                                    </div>
                                </div>
                                <div className="EventTitle_block">
                                        <div className="textarea_block form_group">
                                            <h5 className="left_label">&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                                            <div className="btn_wrapper field_row ml_25">
                                                  <button className="grayBTN">Cancel</button>
                                                  {/* <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecord(e)}>PREviEW</button> */}
                                                  <button className="orangeBTN" type='button' onClick={(e)=>this.villegeHomeSubmit(e)}>Submit</button>
                                            </div> 
                                        </div>
                                </div>
                            </div>
                            
                        </form>
                        {this.state.errorPopup ? 
                        <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                                />    
                            : ''
                        }
                        {this.state.deleteImagePopup
                          ? <PopUpCustomAll
                            HeaderName="Delete Image?"
                            insideDetails="Are You Sure ?"
                            insideData="You want to delete this image"
                            popupState={() => this.closeAdminUser()}
                            yesPopUp={() => this.onDeleteImagePopup()} />
                          : ""
                        }
                    </div>
                </div>
            </div>
            
        )
       
    }
}
